jQuery(function ($) {
  const sections = $('[data-teasers]');

  $.each(sections, function () {
    const section = $(this);

    section.find('.wysiwyg > p:last-child .button').parent().addClass('has-button');
  });
});
